<template>
  <div class="container">
    <div class="row">
      <div class="col-12"></div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-6 col-md-6 font-weight-bold">Detalles de la transferencia</div>
          <div class="col-12 col-lg-6 col-md-6 text-left text-md-right text-sm-right text-lg-right">
            <div><span class="font-weight-bold">ID: </span>#{{ transfer.id }}</div>
            <div><span class="font-weight-bold">Referencia: </span>{{ transfer.reference }}</div>
            <div><span class="font-weight-bold">Fecha: </span>{{ transfer.date }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6 col-md-6 col-sm-6">
            <span class="font-weight-bold">Email: </span>
            <span>{{ transfer.recipient.client.user.email }}</span>
          </div>
          <div class="col-12 col-lg-6 col-md-6 col-sm-6">
            <span class="font-weight-bold h4">Monto: </span>
            <span class="font-weight-bold h4">{{ transfer.amount_display }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-inline-flex">
            <div class="font-weight-bold align-content-start">Descripción:</div>
            <div class="align-content-start ml-1">{{ transfer.comments }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span class="font-weight-bold">Estado: </span>
            <span class="">{{ transfer.status }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TransferDetails",

  props: {
    transfer: {
      type: Object,
      required: true
    }
  }
};
</script>

<style src="@/assets/scss/content.scss" lang="scss" scoped></style>
